(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-footer"]) return;
  try {
    
(async () => {
  if (customElements.get('air-newsletter-popup-component')) return;
  const { DialogComponent } = await import('@theme/dialog');
  class AirNewsletterPopup extends DialogComponent {
    #timer;
    #controller;
    #shown = false;
    #key = 'air-newsletter-popup-v1';
    #subscribedKey = 'air-newsletter-subscribed-v1';
    connectedCallback() {
      super.connectedCallback();
      this.#setup();
    }
    updatedCallback() {
      super.updatedCallback();
      this.#setup();
    }
    disconnectedCallback() {
      clearTimeout(this.#timer);
      this.#controller?.abort();
      super.disconnectedCallback();
    }
    #read(key) {
      try { return localStorage.getItem(key); } catch { return null; }
    }
    #write(key, value) {
      try { localStorage.setItem(key, value); } catch {}
    }
    #setup() {
      clearTimeout(this.#timer);
      this.#controller?.abort();
      this.#controller = new AbortController();
      const signal = this.#controller.signal;
      this.addEventListener('dialog:open', () => {
        this.#shown = true;
        this.#write(this.#key, String(Date.now()));
      }, { signal });
      window.addEventListener('storage', (event) => {
        if (event.key === this.#key || event.key === this.#subscribedKey) {
          clearTimeout(this.#timer);
        }
      }, { signal });
      const form = this.querySelector('form');
      const returnedToPopup = form && location.hash === '#' + form.id;
      const success = this.querySelector('[data-air-newsletter-success]');
      if (success) {
        this.#write(this.#subscribedKey, 'true');
        if (returnedToPopup) this.showDialog();
        return;
      }
      if (returnedToPopup && this.querySelector('[data-air-newsletter-error]')) {
        this.showDialog();
        return;
      }
      if (window.Shopify?.designMode || this.#shown || this.#read(this.#subscribedKey)) return;
      const lastShown = Number(this.#read(this.#key)) || 0;
      if (lastShown && Date.now() - lastShown < 7 * 24 * 60 * 60 * 1000) return;
      this.#timer = setTimeout(() => this.#offer(), Math.max(0, 4000 - performance.now()));
    }
    #offer() {
      if (!this.isConnected || this.#shown || this.#read(this.#subscribedKey)) return;
      const lastShown = Number(this.#read(this.#key)) || 0;
      if (lastShown && Date.now() - lastShown < 7 * 24 * 60 * 60 * 1000) return;
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      if (document.hidden || document.querySelector('dialog[open]') || editing) {
        this.#timer = setTimeout(() => this.#offer(), 1000);
        return;
      }
      this.showDialog();
    }
  }
  customElements.define('air-newsletter-popup-component', AirNewsletterPopup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
